import React from 'react';
import { cn } from '@/utils/cn';

type IconType = React.ComponentType<React.SVGProps<SVGSVGElement>>;

interface ModuleHeaderProps {
  icon: IconType;
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export const ModuleHeader: React.FC<ModuleHeaderProps> = ({
  icon: Icon,
  title,
  subtitle,
  actions,
  className,
}) => {
  return (
    <div
      className={cn(
        'bg-white/90 dark:bg-slate-900/90 border border-slate-200 dark:border-slate-700 rounded-xl px-3 sm:px-6 py-3 sm:py-4 shadow-sm flex flex-col gap-3 sm:gap-4 sm:flex-row sm:items-center sm:justify-between',
        className,
      )}
    >
      <div className="flex items-center gap-3 sm:gap-4">
        <div className="w-8 h-8 sm:w-12 sm:h-12 bg-gradient-to-br from-cyan-500 via-blue-500 to-cyan-600 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg">
          <Icon className="h-4 w-4 sm:h-6 sm:w-6 text-white" />
        </div>
        <div>
          <h1 className="text-base sm:text-2xl font-bold text-slate-900 dark:text-slate-100">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xs sm:text-sm text-slate-500 dark:text-slate-400">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {actions && (
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          {actions}
        </div>
      )}
    </div>
  );
};
